import React from "react";
import { useParams, useNavigate } from "react-router-dom";
import GlobalBreadcrumbs from "../../components/global/GlobalBreadcrumbs";
import WrapperSection from "../../components/global/WrapperSection";
import FormAddEditAgency from "../../components/agencies/FormAddEditAgency";
import { useGetAgency } from "../../hooks/agencies/useGetAgency";
import LoadingPage from "../../components/global/LoadingPage";

const EditAgency = () => {
    const { id } = useParams();
    const navigate = useNavigate();

    const { isLoading, error, data } = useGetAgency(id);
    const agency = data?.data;

    if (isLoading) return <LoadingPage />;
    if (error) return null;

    const handleSuccess = () => {
        navigate("/agencies");
    };

    return (
        <WrapperSection>
            <GlobalBreadcrumbs />
            <FormAddEditAgency
                isEdit={true}
                currentData={agency}
                onSubmitSuccess={handleSuccess}
            />
        </WrapperSection>
    );
};

export default EditAgency;
